export default __webpack_public_path__ + "static/media/cover-card-master-display.bb31a565.svg";